import { Button, IconButton, Input, InputAdornment, Typography, Grid } from '@material-ui/core'
import React, { Dispatch } from 'react'
import { ModemsClient } from '../generated/ApiClient'
import { useDispatch } from "react-redux";
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import { RouteComponentProps } from 'react-router'
import { actionCreators } from '../store/AlertSnackbarStore'
import { isProblemDetails } from '../generated/ApiClientExtensions'
import { Visibility, VisibilityOff } from '@material-ui/icons';

async function formSubmitCallback(modemId: string, dispatch: Dispatch<any>, setPasswordHidden: React.Dispatch<React.SetStateAction<boolean>>, setPassword: React.Dispatch<React.SetStateAction<string>>) {
    try {
        if (modemId) {
            await new ModemsClient().createNewPassword(modemId);
            setPasswordHidden(true)
            setPassword("")
            dispatch(snackbar.addMessage({ title: "Success", message: `New password successfully generated and sent to modem ${modemId}.`, alertType: 'success' }))
        }
    }
    catch (error) {
        dispatch(snackbar.addError(error, undefined, 'Error while updating password to modem.'));
    }
}

export default function ModemPassword(props: { modemId: string }) {
    const dispatch = useDispatch();
    const modemId = props.modemId
    const [passwordHidden, setPasswordHidden] = React.useState(true);
    const [password, setPassword] = React.useState<string>("");

    const onShowPasswordClick = async () => {
        if (passwordHidden) {
            try {
                const result = await new ModemsClient().getPassword(modemId);
                setPassword(result.password);
                setPasswordHidden(false);
            }
            catch (err) {
                if (isProblemDetails(err) && err.status === 404)
                    dispatch(actionCreators.addMessage({ title: "Modem does not currently have a password", message: "A password can be set by clicking the 'Generate New Password' button", alertType: 'info' }))
                else
                    dispatch(actionCreators.addError(err))
            }
        } else {
            setPasswordHidden(true);
        }
    }

    return (
        <Grid container alignItems='baseline' spacing={2}>
            <Grid item>
                <Typography paragraph><b>Password:</b></Typography>
            </Grid>
            <Grid item>
                <Input type={passwordHidden ? 'password' : 'text'} value={password} readOnly endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={onShowPasswordClick}
                            onMouseDown={(event) => event.preventDefault()}
                        >
                            {passwordHidden ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                } />
            </Grid>
            <Grid item>
                <Button variant='contained' color='primary' size='medium' onClick={() => formSubmitCallback(modemId, dispatch, setPasswordHidden, setPassword)}>Generate New Password</Button>
            </Grid>
            <Grid item>
                <Typography>Use 'acuity' as the username</Typography>
            </Grid>
            <Grid item>
                {!passwordHidden && <Typography>To help ensure the modem is not compromised, please reset this password after each use.</Typography>}
            </Grid>
        </Grid>
    )
}